import { useEffect, useRef } from 'react';
import axios from 'axios';
import { useAuthProvider } from './AuthProviderSwitch';
import { getConfigValue } from '../../config/runtimeConfig';

export default function useSecureApi() {
  const { getToken } = useAuthProvider();
  // Create an axios instance with the base URL and default headers
  const api = axios.create({
    baseURL: getConfigValue(
      'REACT_APP_API_BASE_URL',
      process.env.REACT_APP_API_BASE_URL,
      'http://localhost:8081'
    ),
    headers: {
      'Content-Type': 'application/json',
    },
  });

  const apiInstance = useRef(api);

  useEffect(() => {
    const currentApi = apiInstance.current;  // Use a local variable to reference the current api instance.

    const interceptor = currentApi.interceptors.request.use(
      async (config) => {
        if (getToken) {
          try {
            const token = await getToken();
            if (token) {
              config.headers = config.headers || {};
              config.headers.Authorization = `Bearer ${token}`;
            }
          } catch (error) {
            console.error('Failed to attach token', error);
          }
        }
        return config;
      },
      (error) => Promise.reject(error)
    );

    // Cleanup function: safely eject the interceptor.
    return () => {
      currentApi.interceptors.request.eject(interceptor);
    };
  }, [getToken]); // Ensure dependencies are correctly set.

  return apiInstance.current;  // Return the axios instance.
}
